export default __webpack_public_path__ + "static/media/pdf.589f266c.svg";